import firebase from "firebase/app"
import "firebase/auth"

const firebaseConfig = {
	apiKey: "AIzaSyCpNYoQS7F2n3NP8I6L2kZuoMZElDSsCeA",
	authDomain: "podplayer-9d0a0.firebaseapp.com",
	projectId: "podplayer-9d0a0",
	storageBucket: "podplayer-9d0a0.appspot.com",
	messagingSenderId: "259640396686",
	appId: "1:259640396686:web:ea8ed3b805f40bef9832df"
}

// init firebase
firebase.initializeApp(firebaseConfig)

// init firebase authentication
const projectAuth = firebase.auth()

export { projectAuth }